import { useLang } from '@/i18n';
import styles from './index.module.scss';
// import EcoTabSwiper from 'eco-design/sections/eco-tab-swiper';
import EcoSection from 'eco-design/base/eco-section';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EfImg from '@elem/ui/ef-img';
import EcoIconSwiperArrow from 'eco-design-micro/icons/eco-icon-swiper-arrow';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.TabSwiperC');

    // 添加配置数据
    const list = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745461735988/TabSwiper3_img1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745899448267/tu1.jpg',
            desc: t('item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745461736150/TabSwiper3_img2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745899448072/tu2.jpg',
            desc: t('item2_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745890714500/3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745899448628/tu3.jpg',
            desc: t('item3_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745743017403/TabSwiper3_img4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745899447712/tu4.jpg',
            desc: t('item4_desc'),
        },
    ];

    return (
        <div className={styles.comp} id="TabSwiper3">
            <EcoSpace />
            <EcoSection title={t('title')} className="title" />
            <EcoSpaceSmall />
            <div className="swiper-container">
                <Swiper
                    modules={[Navigation]}
                    navigation={{
                        nextEl: '.tabswiper-button-next', // 修改类名
                        prevEl: '.tabswiper-button-prev', // 修改类名
                    }}
                    slidesPerView="auto"
                    centeredSlides={true}
                    loop={true}
                    initialSlide={0}
                    loopedSlides={2}
                    speed={500}
                    className="swiper"
                >
                    {list.map((slide) => (
                        <SwiperSlide className="swiper-item">
                            <div className="slide-content">
                                <EfImg pc={slide.pc} h5={slide.h5} pad={slide.pc} className="slide-image" />
                                <div className="slide-desc">{slide.desc}</div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className="eco-swiper-control eco-swiper-control-white navigation-wrapper">
                <div className="eco-swiper-navigation">
                    <div className="eco-swiper-button-prev tabswiper-button-prev">
                        <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                    </div>
                    <div className="eco-swiper-button-next tabswiper-button-next">
                        <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                    </div>
                </div>
            </div>
        </div>
    );
}
